import React from 'react';
import { observer } from 'mobx-react';
import { Option, OptionWrapper } from 'libs/forms/styles';

export const ColorOption = observer(
  ({ app, highlighted, labelKey, onMouseOver, onClick, scrollRef }) => {
    let { color } = app;
    if (app.color) {
      if (!app.color.startsWith('#')) {
        color = `#${app.color}`;
      }
    }
    return (
      <OptionWrapper
        highlighted={highlighted}
        highlightedColor={color}
        onMouseOver={onMouseOver}
        onClick={onClick}
        ref={scrollRef}
      >
        <Option highlighted={highlighted} highlightedColor={color}>
          {app[labelKey] || 'Untitled'}
        </Option>
      </OptionWrapper>
    );
  },
);
